import { render, staticRenderFns } from "./ebookReviewListOrg.vue?vue&type=template&id=7ee74225&"
import script from "./ebookReviewListOrg.vue?vue&type=script&lang=js&"
export * from "./ebookReviewListOrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports